import { inr0 } from "@/lib/format";

export const BookTab = ({ data }) => {
  if (!data) return null;
  return (
    <div className="space-y-3" data-testid={`book-${data.book}`}>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {[["Opening", data.opening, "opening"], ["Money in", data.total_in, "in"], ["Money out", data.total_out, "out"], ["Closing", data.closing, "closing"]].map(([l, v, k]) => (
          <div key={k} className="rounded-2xl border border-[#E7E2D6] bg-white p-4" data-testid={`book-${data.book}-${k}`}><div className="text-[11px] uppercase tracking-wider text-muted-foreground">{l}</div><div className="font-display text-xl font-semibold text-[#0F382C]">{inr0(v)}</div></div>
        ))}
      </div>
      <div className="overflow-x-auto rounded-2xl border border-[#E7E2D6] bg-white">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground"><th className="p-3">Date</th><th className="p-3">Details</th><th className="p-3 text-right">In</th><th className="p-3 text-right">Out</th><th className="p-3 text-right">Balance</th></tr></thead>
          <tbody>{data.rows.map((e, i) => (
            <tr key={i} className="border-t border-[#F1EDE3]" data-testid={`book-row-${i}`}>
              <td className="p-3 font-mono text-xs">{e.date}</td><td className="p-3">{e.label}</td>
              <td className="p-3 text-right font-mono text-emerald-700">{e.dir === "in" ? inr0(e.amount) : ""}</td>
              <td className="p-3 text-right font-mono text-rose-700">{e.dir === "out" ? inr0(e.amount) : ""}</td>
              <td className="p-3 text-right font-mono font-semibold">{inr0(e.balance)}</td>
            </tr>))}
          </tbody>
        </table>
        {data.rows.length === 0 && <div className="p-6 text-center text-xs text-muted-foreground" data-testid={`book-${data.book}-empty`}>No entries this month</div>}
      </div>
      <div className="text-xs text-muted-foreground">Cash book = cash payments. Bank book = UPI, bank transfer and online (Razorpay) payments.</div>
    </div>
  );
};
